import ApiService from "../ApiService";

export default class PropertyService {
  static getDetail = async (id) => {
    const instance = ApiService();
    return (await instance).get(`/property/${id}`);
  };

  static getList = async (params) => {
    let type, num, keyword, cursor, level, operational_level, parent_id;
    
    if (params.type !== "") {
      type = `&type=${params.type}`;
    }

    if (params.num !== "") {
      num = `num=${params.num || 20}`;
    }

    if (params.cursor !== "") {
      cursor = `&cursor=${params.cursor}`;
    }

    if (params.keyword && params.keyword !== "") {
      keyword = `&keyword=${params.keyword}`;
    }

    if (params.level && params.level !== "") {
      level = `&level=${params.level}`;
    }

    if (params.operational_level && params.operational_level !== "") {
      operational_level = `&operational_level=${params.operational_level}`;
    }

    if (params.parent_id && params.parent_id !== "") {
      parent_id = `&parent_id=${params.parent_id}`;
    }

    const instance = await ApiService();
    return instance.get(
      `/property?${num}${type || ""}${cursor || ""}${keyword || ""}${
        level || ""
      }${operational_level || ""}${parent_id || ""}`
    );
  };

  static storeData = async (params) => {
    const instance = await ApiService();
    return instance.post(`/property`, params);
  };

  static putData = async (params) => {
    const instance = await ApiService();
    return instance.put(`/property/${params?.id}`, params);
  };

  static deleteData = async (id) => {
    const instance = await ApiService();
    return instance.delete(`/property/${id}`);
  };
}
